import { useEffect, useState } from 'react';
import { FaPhone, FaWhatsapp, FaClock, FaMapMarkerAlt, FaStar, FaAward, FaHeart, FaLeaf, FaSpa, FaGem } from 'react-icons/fa';
import styles from './Hero.module.css';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleCall = () => {
    window.open('tel:+919288595970', '_self');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919288595970?text=Hi, I would like to book a massage appointment', '_blank');
  };

  return (
    <section className={styles.hero} id="hero">
      {/* Background Image Layer */}
      <div className={styles.heroBgImage}></div>
      
      {/* Dark Overlay Layer */}
      <div className={styles.heroOverlay}></div>

      <div className={styles.heroBackground}>
        <div className={styles.particles}>
          {[...Array(40)].map((_, i) => (
            <div key={i} className={styles.particle} style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 20}s`,
              animationDuration: `${15 + Math.random() * 10}s`
            }}></div>
          ))}
        </div>

        <div className={styles.floatingIcons}>
          <FaSpa className={`${styles.floatingIcon} ${styles.icon1}`} />
          <FaGem className={`${styles.floatingIcon} ${styles.icon2}`} />
          <FaLeaf className={`${styles.floatingIcon} ${styles.icon3}`} />
          <FaHeart className={`${styles.floatingIcon} ${styles.icon4}`} />
        </div>
      </div>

      <div className={styles.heroContent}>
        
        {/* Left Side: Text Content */}
        <div className={`${styles.heroText} ${isVisible ? styles.fadeIn : ''}`}>
          <div className={styles.badge}>
            <FaSpa className={styles.badgeIcon} />
            <span>Premium Wellness</span>
          </div>

          <h1 className={styles.heroTitle}>
            <span className={styles.titleMain}>Arpita Spa &</span>
            <span className={styles.titleSub}>Home Massage</span>
            <span className={styles.titleLocation}>
              <FaMapMarkerAlt className={styles.locationPin} /> NOIDA
            </span>
          </h1>

          <p className={styles.heroDescription}>
            Escape the chaos. Experience the ultimate relaxation with our expert therapists in a serene, luxury environment right at your doorstep.
          </p>

          <div className={styles.highlights}>
            <div className={styles.highlight}>
              <div className={styles.highlightIconBox}><FaStar /></div>
              <span>5-Star Rated</span>
            </div>
            <div className={styles.highlight}>
              <div className={styles.highlightIconBox}><FaClock /></div>
              <span>24/7 Service</span>
            </div>
            <div className={styles.highlight}>
              <div className={styles.highlightIconBox}><FaAward /></div>
              <span>Certified</span>
            </div>
          </div>

          <div className={styles.ctaButtons}>
            <button className={styles.primaryBtn} onClick={handleCall}>
              <FaPhone />
              <span>Call Now</span>
              <div className={styles.btnGlow}></div>
            </button>
            <button className={styles.secondaryBtn} onClick={handleWhatsApp}>
              <FaWhatsapp />
              <span>Book Appointment</span>
            </button>
          </div>
        </div>

        {/* Right Side: Glass Card */}
        <div className={`${styles.contactCard} ${isVisible ? styles.slideUp : ''}`}>
          <div className={styles.cardHeader}>
            <div className={styles.onlineIndicator}></div>
            <h3>Quick Booking</h3>
          </div>

          <div className={styles.cardContent}>
            <div className={styles.contactItem}>
              <div className={styles.iconCircle}>
                <FaPhone />
              </div>
              <div className={styles.contactDetails}>
                <span className={styles.label}>Direct Call</span>
                <span className={styles.value}>+91 92885 95970</span>
              </div>
            </div>

            <div className={styles.contactItem}>
              <div className={styles.iconCircle}>
                <FaClock />
              </div>
              <div className={styles.contactDetails}>
                <span className={styles.label}>Availability</span>
                <span className={styles.value}>Open 24/7 Daily</span>
              </div>
            </div>

            <div className={styles.contactItem}>
              <div className={styles.iconCircle}>
                <FaMapMarkerAlt />
              </div>
              <div className={styles.contactDetails}>
                <span className={styles.label}>Service Area</span>
                <span className={styles.value}>Khora Rd, Sector 62</span>
              </div>
            </div>
            
            <div className={styles.cardFooter}>
               <span><FaLeaf className={styles.miniIcon}/> 100% Natural Oils</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;